import React from 'react';
import { Alert, Space, Typography } from 'antd';
import Modal from '../../Modal';
import PosButton from '../../PosButton';
import { SyncOutlined } from '@ant-design/icons';

const DataInvalidatedModal: React.FC<{
  posDataVersionLatest: number;
  onRequestIgnore: () => void;
  onRequestSync: () => void;
}> = ({ posDataVersionLatest, onRequestIgnore, onRequestSync }) => {
  return (
    <>
      {posDataVersionLatest > -1 && (
        <Modal
          destroyOnHidden
          open={true}
          closable={false}
          closeIcon={null}
          style={{ background: 'transparent', overflow: 'hidden', borderRadius: 6, padding: 0 }}
          styles={{ body: { padding: 0 } }}
          footer={null}>
          <Alert
            type={'warning'}
            showIcon
            message={'数据已过期'}
            description={
              <>
                <Typography.Paragraph>
                  检测到该设备上的数据已过期，需要重新同步数据
                </Typography.Paragraph>
                <Space direction={'horizontal'} size={20}>
                  <PosButton
                    ghost
                    danger
                    onClick={() => {
                      // POS_DATA_VERSION = posDataVersionLatest;
                      // setPosDataVersionLatest(-1);
                      onRequestIgnore();
                    }}>
                    忽略
                  </PosButton>
                  <PosButton
                    type={'primary'}
                    ghost
                    icon={<SyncOutlined />}
                    onClick={() => {
                      // POS_DATA_VERSION = posDataVersionLatest;
                      // setPosDataVersionLatest(-1);
                      // resetAndSync();
                      onRequestSync();
                    }}>
                    立即同步
                  </PosButton>
                </Space>
              </>
            }
          />
        </Modal>
      )}
    </>
  );
};

export default DataInvalidatedModal;
